"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _base = _interopRequireWildcard(require("./_base"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var menu = _objectSpread(_objectSpread({}, _base["default"].menu), {}, {
  openWidth: "250px",
  logo: "34px",
  iconSize: "16px"
});
var fields = _objectSpread(_objectSpread({}, _base["default"].fields), {}, {
  checkBorderRadius: _base["default"].borderRadius.s,
  labelAbove: true
});
var layouts = _objectSpread(_objectSpread({}, _base["default"].layouts), {}, {
  // backgroundColor for main section
  backgroundColor: "backgroundSecondary"
});
var palette = {
  purple: "#C24D9C",
  //   primary purple
  purple_1: "#FFE5F7",
  // shade lightest
  purple_2: "#ED8ACD",
  // shade lighter
  purple_3: "#AB2981",
  // shade darker
  purple_4: "#770051",
  // shade darkest

  light: "#FFFFFF",
  //   (HS)L 100 (lightest)
  light_1: "#FAFAFA",
  // (HS)L 98
  light_2: "#EDEDED",
  // (HS)L 92.9
  light_3: "#DEDEDE",
  // (HS)L 87.1
  light_4: "#BCBCBC",
  // (HS)L 73.7

  dark: "#222222",
  //   (HS)L 13.3 (darkest)
  dark_1: "#909090",
  // (HS)L 56.5
  dark_2: "#646464",
  // (HS)L 39.2
  dark_3: "#474747",
  // (HS)L 27.8
  dark_4: "#323232",
  // (HS)L 19.6

  green: "#93BB48",
  //   primary green
  green_1: "#E4F4C4",
  // shade lightest
  green_2: "#C2E77D",
  // shade light
  green_3: "#739B28",
  // shade darker
  green_4: "#435F0F",
  // shade darkest

  yellow: "#FFB12A",
  //   primary yellow
  yellow_1: "#FFF4E2",
  // shade lightest
  yellow_2: "#FFCE78",
  // shade lighter
  yellow_3: "#E2940B",
  // shade darker
  yellow_4: "#8F5D06",
  // shade darkest

  orange: "#E9781D",
  //   primary orange
  orange_1: "#FFCDA5",
  // shade lightest
  orange_2: "#F68E3B",
  // shade lighter
  orange_3: "#CC630E",
  // shade darker
  orange_4: "#813E07",
  // shade darkest

  red: "#F44B16",
  //   primary red
  red_1: "#FDDBD0",
  // shade lightest
  red_2: "#FCA78C",
  // shade lighter
  red_3: "#D74010",
  // shade darker
  red_4: "#8B2100",
  // shade darkest

  turquoise: "#03CEA4",
  turquoise_1: "#DFFFF8",
  // shade lightest
  turquoise_2: "#1AE7BC",
  // shade light
  turquoise_3: "#00785F",
  // shade darker
  turquoise_4: "#074639",
  // shade darkest

  blue: "#2A7AFF",
  //   primary blue
  blue_1: "#CCE0F6",
  // shade lightest
  blue_2: "#66A3E5",
  // shade light
  blue_3: "#055DBF",
  // shade darker
  blue_4: "#074891" // shade darkest
};

var colors = _objectSpread(_objectSpread({}, _base.baseColorTokens), {}, {
  primary: palette.purple,
  //     primary purple
  primary_1: palette.purple_1,
  // shade lightest
  primary_2: palette.purple_2,
  // shade light
  primary_3: palette.purple_3,
  // shade darker
  primary_4: palette.purple_4,
  // shade darkest

  success: palette.turquoise,
  //     primary turquoise
  success_1: palette.turquoise_1,
  // shade lightest
  success_2: palette.turquoise_2,
  // shade light
  success_3: palette.turquoise_3,
  // shade darker
  success_4: palette.turquoise_4,
  // shade darkest

  warning: palette.yellow,
  //     primary yellow
  warning_1: palette.yellow_1,
  // shade lightest
  warning_2: palette.yellow_2,
  // shade light
  warning_3: palette.yellow_3,
  // shade darker
  warning_4: palette.yellow_4,
  // shade darkest

  error: palette.red,
  error_1: palette.red_1,
  // shade lightest
  error_2: palette.red_2,
  // shade light
  error_3: palette.red_3,
  // shade darker
  error_4: palette.red_4,
  // shade darkest

  border: palette.light_3,
  backgroundPrimary: palette.light,
  backgroundSecondary: palette.light_1,
  backgroundTertiary: palette.light_2,
  backgroundFourth: palette.light_3,
  text: palette.dark,
  textSecondary: palette.dark_1,
  textTertiary: palette.light_4,
  textInverted: palette.light,
  label: palette.dark,
  focus: palette.purple,
  radioCheckBackground: palette.purple,
  inputBackground: palette.light_2,
  inputButton: palette.dark,
  inputIcon: palette.dark_1,
  tableHeadText: palette.dark_2,
  radioCheckInactive: palette.light_4,
  tagBackground: palette.light_2,
  menuBackground: palette.light,
  menuItem: palette.dark,
  menuIconActive: palette.purple,
  menuBackgroundActive: palette.purple_1,
  // Colors "palette" should be used directly ONLY IF THERE ISN'T A TOKEN that
  // is better suited for that color. NEVER USE palette colors in Smalt
  // components as they are theme specific and might be missing in some themes
  palette: _objectSpread({}, palette)
});
var adrTheme = _objectSpread(_objectSpread({}, _base["default"]), {}, {
  menu: menu,
  fields: fields,
  layouts: layouts,
  colors: colors
});
var _default = adrTheme;
exports["default"] = _default;